module.exports = "/../../dist/frontend/images/citadine.webp?cc27e63f3d3f8409282c535d7631a6f8";